export enum GuestPassStatus {
  ACTIVE = 'active',
  REDEEMED = 'redeemed',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled'
}

export interface GuestPass {
  id: string;
  memberProfileId?: string;
  guestName: string;
  guestEmail: string;
  guestPhone?: string;
  code: string;
  issuedAt: string;
  validUntil: string;
  redeemedAt?: string;
  status: GuestPassStatus;
  transactionId?: string;
  issuedByUserId?: string;
  guestMemberProfileId?: string | null;
  notes?: string;
  createdAt: string;
  updatedAt: string;
  memberProfile?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  guestMemberProfile?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface CreateGuestPassRequest {
  memberProfileId?: string;
  guestName: string;
  guestEmail: string;
  guestPhone?: string;
  notes?: string;
  isComplimentary?: boolean;
  guestMemberProfileId?: string;
}

export interface GuestAccessValidation {
  allowed: boolean;
  count: number;
  limit: number;
}

export interface MemberSponsorshipValidation {
  allowed: boolean;
  count: number;
  limit: number;
}
